import { declOfNum } from '../../helpers';
import styles from '../../styles/modules/building/BuildingFlags.module.scss';

const BuildingFlags = ({ data }) => {
  return (
    <section className="block">
      <div className="fixed">
        <div className={styles.flags}>
          {data['built-year'] && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M45.3333 10H12.6667C10.0893 10 8 12.0893 8 14.6667V47.3333C8 49.9107 10.0893 52 12.6667 52H45.3333C47.9107 52 50 49.9107 50 47.3333V14.6667C50 12.0893 47.9107 10 45.3333 10Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18 32H16C15.4477 32 15 32.4477 15 33V35C15 35.5523 15.4477 36 16 36H18C18.5523 36 19 35.5523 19 35V33C19 32.4477 18.5523 32 18 32Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18 40H16C15.4477 40 15 40.4477 15 41V43C15 43.5523 15.4477 44 16 44H18C18.5523 44 19 43.5523 19 43V41C19 40.4477 18.5523 40 18 40Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M42 32H40C39.4477 32 39 32.4477 39 33V35C39 35.5523 39.4477 36 40 36H42C42.5523 36 43 35.5523 43 35V33C43 32.4477 42.5523 32 42 32Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M42 40H40C39.4477 40 39 40.4477 39 41V43C39 43.5523 39.4477 44 40 44H42C42.5523 44 43 43.5523 43 43V41C43 40.4477 42.5523 40 42 40Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M34 32H32C31.4477 32 31 32.4477 31 33V35C31 35.5523 31.4477 36 32 36H34C34.5523 36 35 35.5523 35 35V33C35 32.4477 34.5523 32 34 32Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M34 40H32C31.4477 40 31 40.4477 31 41V43C31 43.5523 31.4477 44 32 44H34C34.5523 44 35 43.5523 35 43V41C35 40.4477 34.5523 40 34 40Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M26 32H24C23.4477 32 23 32.4477 23 33V35C23 35.5523 23.4477 36 24 36H26C26.5523 36 27 35.5523 27 35V33C27 32.4477 26.5523 32 26 32Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M26 40H24C23.4477 40 23 40.4477 23 41V43C23 43.5523 23.4477 44 24 44H26C26.5523 44 27 43.5523 27 43V41C27 40.4477 26.5523 40 26 40Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M41 5V14"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M33 5V14"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M25 5V14"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17 5V14"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 24L50 24"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>
                  {data['built-year'].min === data['built-year'].max
                    ? data['built-year'].min
                    : `${data['built-year'].min}—${data['built-year'].max}`}
                </div>
                <div className={styles.flagContentDescription}>Срок сдачи</div>
              </div>
            </div>
          )}
          {data['floors-total'] && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M29 6L6 17.5L29 29L52 17.5L29 6Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M40 23.5L52 29.5L29 41L6 29.5L18 23.5"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M41 35C44.34 36.67 47.7225 38.3613 52 40.5L29 52L6 40.5L17 35"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>
                  {data['floors-total'].min === data['floors-total'].max
                    ? data['floors-total'].min
                    : `${data['floors-total'].min}—${data['floors-total'].max}`}
                </div>
                <div className={styles.flagContentDescription}>Этажность</div>
              </div>
            </div>
          )}
          {data.buildingsCount && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M8 7V51C8 51.5523 8.44771 52 9 52H26C26.5523 52 27 51.5523 27 51V7C27 6.44772 26.5523 6 26 6H9C8.44772 6 8 6.44772 8 7Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13 18.5V12C13 11.4477 13.4477 11 14 11H15C15.5523 11 16 11.4477 16 12V18.5C16 19.0523 15.5523 19.5 15 19.5H14C13.4477 19.5 13 19.0523 13 18.5Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13 35.5V29C13 28.4477 13.4477 28 14 28H15C15.5523 28 16 28.4477 16 29V35.5C16 36.0523 15.5523 36.5 15 36.5H14C13.4477 36.5 13 36.0523 13 35.5Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M32 46V43C32 42.4477 32.4477 42 33 42H34C34.5523 42 35 42.4477 35 43V46C35 46.5523 34.5523 47 34 47H33C32.4477 47 32 46.5523 32 46Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M32 35.5V29C32 28.4477 32.4477 28 33 28H34C34.5523 28 35 28.4477 35 29V35.5C35 36.0523 34.5523 36.5 34 36.5H33C32.4477 36.5 32 36.0523 32 35.5Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19 18.5V12C19 11.4477 19.4477 11 20 11H21C21.5523 11 22 11.4477 22 12V18.5C22 19.0523 21.5523 19.5 21 19.5H20C19.4477 19.5 19 19.0523 19 18.5Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19 35.5V29C19 28.4477 19.4477 28 20 28H21C21.5523 28 22 28.4477 22 29V35.5C22 36.0523 21.5523 36.5 21 36.5H20C19.4477 36.5 19 36.0523 19 35.5Z"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M25 52H39C39.5523 52 40 51.5523 40 51V24C40 23.4477 39.5523 23 39 23H27"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M48 52V48"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M52 41C52 44.3137 52 47 48 47C44 47 44 44.3137 44 41C44 37.6863 45.7909 32 48 32C50.2091 32 52 37.6863 52 41Z"
                    stroke="#757575"
                    strokeWidth="2"
                  />
                  <path
                    d="M15 52V43C15 42.4477 15.4477 42 16 42H19C19.5523 42 20 42.4477 20 43V52"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>{data.buildingsCount}</div>
                <div className={styles.flagContentDescription}>
                  {declOfNum(data.buildingsCount, ['Корпус', 'Корпуса', 'Корпусов'])}
                </div>
              </div>
            </div>
          )}
          {data['building-type'] && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M7 18V8C7 7.44772 7.44771 7 8 7H18V18H7Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 40V29H18V40H7Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18 18V7H39C39.5523 7 40 7.44771 40 8V17C40 17.5523 39.5523 18 39 18H18Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18 40V29H39C39.5523 29 40 29.4477 40 30V39C40 39.5523 39.5523 40 39 40H18Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 29V18H28C28.5523 18 29 18.4477 29 19V29H7Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 51V40H28C28.5523 40 29 40.4477 29 41V51H7Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29 29V18H50C50.5523 18 51 18.4477 51 19V28C51 28.5523 50.5523 29 50 29H29Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29 51V40H50C50.5523 40 51 40.4477 51 41V50C51 50.5523 50.5523 51 50 51H29Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>
                  {data['building-type'][0].toUpperCase() + data['building-type'].slice(1)}
                </div>
                <div className={styles.flagContentDescription}>Тип дома</div>
              </div>
            </div>
          )}
          {data['ceiling-height'] !== 0 && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M10 8H48"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29 32.5V50"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 39L44 39"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.7236 32.5528L8.72361 48.5528C8.39116 49.2177 8.87465 50 9.61803 50H48.382C49.1253 50 49.6088 49.2177 49.2764 48.5528L41.2764 32.5528C41.107 32.214 40.7607 32 40.382 32H17.618C17.2393 32 16.893 32.214 16.7236 32.5528Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M29 12V27.5M29 12L25.5 15.5M29 12L32.5 15.5M29 27.5L25.5 24M29 27.5L32.5 24"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>{data['ceiling-height']}</div>
                <div className={styles.flagContentDescription}>Высота потолков</div>
              </div>
            </div>
          )}
          {data.renovation && (
            <div className={styles.flag}>
              <div className={styles.flagIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                >
                  <path
                    d="M34 8L22 22"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M41 8L29 22"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M36 22L45 11.5"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M27 8L15 22"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 8L13 16.1667"
                    stroke="#C0C0C0"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M44 8H14C13.4477 8 13 8.44772 13 9V21C13 21.5523 13.4477 22 14 22H44C44.5523 22 45 21.5523 45 21V9C45 8.44772 44.5523 8 44 8Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15 23V31"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19 23V27"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M50.5 15V24C50.5 24 50.5 24 50.5 24C50.5 24 50.5 28 47.5 28C44.5 28 44 28 44 28C44 28 44 28 44 28H31.5C31.5 28 31.5 28 31.5 28C31.5 28 29 28 29 31C29 34 29 35.5 29 35.5"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M32.0008 36H25.9996C25.4474 36 25 36.4477 25 37V48.5C25 48.5 25 52 29 52C33 52 33 48.5 33 48.5V37C33 36.4477 32.5531 36 32.0008 36Z"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.flagContent}>
                <div className={styles.flagContentTitle}>{data.renovation.join(', ')}</div>
                <div className={styles.flagContentDescription}>Варианты отделки</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BuildingFlags;
